import type { HeadingProps } from "@chakra-ui/react"
import { Heading } from "@chakra-ui/react"

const H2 = ({ children, ...props }: HeadingProps) => {
  return (
    <Heading
      as={"h2"}
      mt={10}
      fontSize={{ base: "lg", md: "xl" }}
      fontWeight={400}
      textAlign={"center"}
      {...props}
    >
      {children}
    </Heading>
  )
}

export default H2
